import LearnPageLayout from "@/components/LearnPageLayout";
import { pageWhatToExpect } from "./learnDataWhatToExpect";

const WhatToExpectSaintPage = () => (
  <LearnPageLayout
    title={pageWhatToExpect.title}
    description={pageWhatToExpect.description}
    canonical={pageWhatToExpect.canonical}
    h1={pageWhatToExpect.h1}
    breadcrumbLabel={pageWhatToExpect.breadcrumbLabel}
    crumbs={pageWhatToExpect.crumbs}
    shortAnswer={pageWhatToExpect.shortAnswer}
    keyTakeaways={pageWhatToExpect.keyTakeaways}
    sections={pageWhatToExpect.sections}
    faqs={pageWhatToExpect.faqs}
    sources={pageWhatToExpect.sources}
    schemaJson={pageWhatToExpect.schemaJson}
    relatedLinks={pageWhatToExpect.relatedLinks}
    reviewBlock={pageWhatToExpect.reviewBlock}
  />
);

export default WhatToExpectSaintPage;
